import { Link } from 'react-router-dom'
import { BellIcon as Bell } from '@/components/icons/lucide-bell'
import { HeartIcon as Heart } from '@/components/icons/lucide-heart'
import { MessageSquareIcon as MessageSquare } from '@/components/icons/lucide-message-square'
import { StarIcon as Star } from '@/components/icons/lucide-star'
import { UserPlusIcon as UserPlus } from '@/components/icons/lucide-user-plus'
import { AtSignIcon as AtSign } from '@/components/icons/lucide-at-sign'
import { SettingsIcon as Settings } from '@/components/icons/lucide-settings'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useUnreadNotificationCount, useNotificationsInsertRealtime } from '@/hooks/use-notifications'

interface NotificationBadgeProps {
  className?: string
}

export function NotificationBadge({ className }: NotificationBadgeProps) {
  useNotificationsInsertRealtime(true)
  const { data: unreadCount } = useUnreadNotificationCount()

  return (
    <Link to="/notifications">
      <Button variant="ghost" size="icon" className={cn('relative', className)}>
        <Bell className="h-5 w-5" />
        {unreadCount && unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-destructive text-destructive-foreground text-xs flex items-center justify-center font-medium">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </Button>
    </Link>
  )
}